import React from 'react'
import moment from 'moment'
import { pick } from 'lodash'
import { Helmet } from 'react-helmet'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, withHandlers, lifecycle } from 'recompose'

import Comments from './Comments'
import Share from './../components/Sidebar/Share'

import { getSingle } from '../store/reducers/news'
import { getFullArticle } from '../selectors/news.js'
import { fetchingState } from '../helpers/hocs.js'

const Article = ({ articleId, article, fetching }) => {
  if (!article || fetching) return null
  const { meta } = article

  return (
    <div className='Container Container_no-top'>
      <Helmet>
        <title>{`${meta.title} - Meet For Charity`}</title>
        <meta name='description' content={meta.description} />
        <meta property='og:title' content={meta.title} />
        <meta property='og:image' content={meta.image} />
        <meta property='og:url' content={window.location.href} />
        <meta property='og:description' content={meta.description} />
      </Helmet>
      <div className='Article__hero'>
        <div className='Article__img-wrap'>
          <img className='Article__img' src={article.image} alt={article.title} />
        </div>
        <div className='Article__headline'>
          <span className='Text'>{moment(article.created).from(moment())}</span>
          <h1 className='Article__title Head'>{article.title}</h1>
        </div>
      </div>

      <div className='Article__content'>
        <div className='Article__body Text' dangerouslySetInnerHTML={{ __html: article.description }} />
        <Share className={'Article__share'} meta={pick(article, [ 'title', 'description', 'image' ])} />
      </div>
      <div className='Article__comments'>
        <Comments type='articles' entryId={articleId} />
      </div>
    </div>
  )
}

const mapStateToProps = () => {
  const getArticle = getFullArticle()
  return (state, props) => ({
    article: getArticle(state, props)
  })
}

const mapDispatchToProps = dispatch => bindActionCreators({ getArticle: getSingle }, dispatch)

export default compose(
  fetchingState(),
  connect(mapStateToProps, mapDispatchToProps),
  withHandlers({
    getArticle: ({ getArticle, article, articleId, fetchingWrap, on404 }) => async newId => {
      articleId = newId || articleId
      if (!articleId) return
      const result = await fetchingWrap(getArticle.bind(this, articleId))
      if (result !== 200) on404()
    }
  }),
  lifecycle({
    componentWillMount () {
      this.props.getArticle()
    }
  })
)(Article)



// WEBPACK FOOTER //
// ./src/containers/Article.jsx